<template>
    <div>
        <x-table-server ref="refStoreTableServer"
                        :title="title"
                        :resource="resource"
                        :show-filter="true"
                        :show-button-new="false"
                        :show-button-export="true"
                        :show-widgets="true"
                        :show-button-other-reports="true"
                        :reload-table-server.sync="reloadTableServer"
                        @click-other-reports="clickReports()">
            <template v-slot:table-rows="props">
                <tr v-for="row in props.records">
                    <td v-for="col in props.columns" :class="col.class_col_body" :key="col['name']">
                        <template v-if="col['name'] === 'actions'">
                            <x-button-icon icon="fa-light fa-ellipsis-vertical"
                                           class="x-button-icon-small"
                                           @click="clickDialogInformation(row.id)"></x-button-icon>
                        </template>
                        <template v-else-if="col['name'] === 'date_of_issue'">
                            {{ row.date_of_issue }}<br/>{{ row.time_of_issue }}
                        </template>
                        <template v-else>
                            {{ row[col['name']] }}
                        </template>
                    </td>
                </tr>
            </template>
        </x-table-server>

        <modal-report :showDialog.sync="showDialog"></modal-report>
    </div>
</template>

<script>

import ModalReport from "./partials/Modal.vue";
import XTableServer from "../../../../components/Form/XTableServer.vue";
import XButtonPrimary from "../../../../components/Form/XButtonPrimary.vue";
import XButtonDownload from "../../../../components/Form/XButtonDownload.vue";
import XButtonIcon from "../../../../components/Form/XButtonIcon.vue";

export default {
    name: 'InventoryReportIndex',
    components: {
        XButtonIcon, XButtonDownload, XButtonPrimary, XTableServer, ModalReport
    },
    data() {
        return {
            title: 'Consulta de inventario',
            resource: 'inventory/report2',
            recordId: null,
            showDialog: false,
            showDialogInformation: false,
            reloadTableServer: false,
        }
    },
    methods: {
        clickCreate() {
            this.showDialog = true;
        },
        clickDialogInformation(id) {
            this.recordId = id;
            this.showDialogInformation = true;
        },
        clickReports() {
            this.showDialog = true;
            // location.href = `/${this.resource}/create`;
        }
    }
}
</script>
